(function () {
  var root = document.querySelector("[data-pcro]");
  if (!root) return;

  var jsonEl = document.querySelector("[data-pcro-json]");
  var data = { variants: {} };
  if (jsonEl) {
    try {
      var parsed = JSON.parse(jsonEl.textContent);
      if (parsed && parsed.variants) data = parsed;
    } catch (e) {
      data = { variants: {} };
    }
  }

  var variantInput = root.querySelector("[data-pcro-variant-input]");
  var planInput = root.querySelector("[data-pcro-plan-input]");
  var priceNow = root.querySelector("[data-pcro-price-now]");
  var priceWas = root.querySelector("[data-pcro-price-was]");
  var priceBadge = root.querySelector("[data-pcro-price-badge]");
  var atc = root.querySelector("[data-pcro-atc]");
  var atcText = root.querySelector("[data-pcro-atc-text]");
  var atcPrice = root.querySelector("[data-pcro-atc-price]");
  var freq = root.querySelector("[data-pcro-frequency]");
  var optionCount = root.querySelectorAll("[data-pcro-option]").length;
  var note = root.querySelector("[data-pcro-note]");
  var form = root.querySelector("[data-pcro-form]");
  var qtyInput = root.querySelector("[data-pcro-qty-input]");
  var subNow = root.querySelector('[data-pcro-plan-now="subscribe"]');
  var subWas = root.querySelector('[data-pcro-plan-was="subscribe"]');
  var oneNow = root.querySelector('[data-pcro-plan-now="onetime"]');
  var subServing = root.querySelector('[data-pcro-plan-serving="subscribe"]');
  var oneServing = root.querySelector('[data-pcro-plan-serving="onetime"]');
  var planBanner = root.querySelector("[data-pcro-plan-banner]");
  var planOff = root.querySelector("[data-pcro-plan-off]");
  var freqLabel = root.querySelector("[data-pcro-plan-freqlabel]");
  var galTrack = root.querySelector("[data-pcro-gal-track]");
  var galSlides = root.querySelectorAll("[data-pcro-gal-slide]");
  var thumbTrack = root.querySelector("[data-pcro-gal-thumbs]");
  var sticky = document.querySelector("[data-pcro-sticky]");
  var stickyBtn = document.querySelector("[data-pcro-sticky-atc]");
  var stickyText = document.querySelector("[data-pcro-sticky-text]");
  var stickyPrice = document.querySelector("[data-pcro-sticky-price]");
  var stickyMode = document.querySelector("[data-pcro-sticky-mode]");
  var servings = parseInt(data.servings, 10) || 0;

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function perServing(cents) {
    if (!servings) return "";
    return "$" + (cents / 100 / servings).toFixed(2) + "/serving";
  }

  function setServing(el, cents) {
    if (!el) return;
    var text = perServing(cents);
    el.textContent = text;
    el.hidden = !text;
  }

  function currentVariant() {
    if (!variantInput) return null;
    return data.variants[variantInput.value] || null;
  }

  function subscribeSelected() {
    var checked = root.querySelector("[data-pcro-mode]:checked");
    return !!checked && checked.value === "subscribe";
  }

  function selectedPlanId() {
    var v = currentVariant();
    var plans = (v && v.plans) || {};
    if (freq && freq.value && plans[freq.value] != null) return freq.value;
    var keys = Object.keys(plans);
    return keys.length ? keys[0] : "";
  }

  function subPriceFor(v) {
    if (!v) return 0;
    var id = selectedPlanId();
    if (id && v.plans && v.plans[id] != null) return v.plans[id];
    return v.price;
  }

  function pricing() {
    var v = currentVariant();
    if (!v) return { now: 0, was: 0 };
    if (subscribeSelected()) {
      var sub = subPriceFor(v);
      if (sub < v.price) return { now: sub, was: v.price };
      return { now: sub, was: v.compare_at > sub ? v.compare_at : 0 };
    }
    return { now: v.price, was: v.compare_at > v.price ? v.compare_at : 0 };
  }

  function syncPlanInput() {
    if (!planInput) return;
    var id = subscribeSelected() ? selectedPlanId() : "";
    if (id) {
      planInput.value = id;
      planInput.disabled = false;
    } else {
      planInput.value = "";
      planInput.disabled = true;
    }
  }

  function syncCards() {
    root.querySelectorAll("[data-pcro-plan-card]").forEach(function (card) {
      var input = card.querySelector("[data-pcro-mode]");
      var open = !!input && input.checked;
      card.classList.toggle("is-open", open);
      var body = card.querySelector("[data-pcro-plan-body]");
      if (body) body.hidden = !open;
    });
    if (note) note.hidden = !subscribeSelected();
  }

  function syncPlanPrices() {
    var v = currentVariant();
    if (!v) return;
    var sub = subPriceFor(v);
    if (subNow) subNow.textContent = money(sub);
    if (subWas) {
      subWas.textContent = money(v.price);
      subWas.hidden = sub >= v.price;
    }
    if (oneNow) oneNow.textContent = money(v.price);
    setServing(subServing, sub);
    setServing(oneServing, v.price);
    var pct = v.price > 0 ? Math.round((v.price - sub) / v.price * 100) : 0;
    if (planBanner) {
      planBanner.textContent = "Most popular: get " + pct + "% off";
      planBanner.hidden = pct <= 0;
    }
    if (planOff) {
      planOff.textContent = "Save " + pct + "%";
      planOff.hidden = pct <= 0;
    }
    if (freqLabel && freq && freq.options && freq.selectedIndex >= 0) {
      var opt = freq.options[freq.selectedIndex];
      if (opt) freqLabel.textContent = opt.textContent;
    }
  }

  function syncPrice() {
    var p = pricing();
    if (priceNow) priceNow.textContent = money(p.now);
    if (priceWas) {
      priceWas.textContent = p.was ? money(p.was) : "";
      priceWas.hidden = !p.was;
    }
    if (priceBadge) {
      if (p.was && p.was > p.now) {
        priceBadge.textContent = "Save " + Math.round((p.was - p.now) / p.was * 100) + "%";
        priceBadge.hidden = false;
      } else {
        priceBadge.hidden = true;
      }
    }
    if (atcPrice) atcPrice.textContent = money(p.now);
  }

  function syncSticky() {
    if (!sticky) return;
    var v = currentVariant();
    var p = pricing();
    if (stickyPrice) stickyPrice.textContent = money(p.now);
    if (stickyText) stickyText.textContent = v && v.available ? "Add to cart" : "Sold out";
    if (stickyBtn) stickyBtn.disabled = !v || !v.available;
    if (stickyMode) {
      stickyMode.textContent = subscribeSelected() && freqLabel
        ? "Subscription · " + freqLabel.textContent.trim()
        : "One-time purchase";
    }
  }

  var atcResetTimer = null;

  function idleAtcLabel() {
    var v = currentVariant();
    return v && v.available ? "Add to cart" : "Sold out";
  }

  function setAtcState(state) {
    [atc, stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.classList.toggle("is-loading", state === "loading");
      btn.classList.toggle("is-success", state === "success");
      if (state === "loading") btn.disabled = true;
      else if (state !== "success") btn.disabled = false;
    });
    if (state === "success") {
      if (atcText) atcText.textContent = "Added to cart";
      if (stickyText) stickyText.textContent = "Added";
    } else if (state === "idle") {
      var label = idleAtcLabel();
      if (atcText) atcText.textContent = label;
      if (stickyText) stickyText.textContent = label;
    }
  }

  function syncPlanAvailability() {
    var v = currentVariant();
    var has = !!(v && v.plans && Object.keys(v.plans).length);
    var subCard = root.querySelector('[data-pcro-plan-card="subscribe"]');
    if (subCard) subCard.hidden = !has;
    if (!has) {
      var oneRadio = root.querySelector('[data-pcro-plan-card="onetime"] [data-pcro-mode]');
      if (oneRadio) oneRadio.checked = true;
    }
  }

  function syncAll() {
    syncPlanAvailability();
    syncCards();
    syncPlanInput();
    syncPlanPrices();
    syncPrice();
    syncSticky();
  }

  var swiped = false;
  var thumbLoop = false;
  var thumbSetWidth = 0;

  function jumpScroll(el, left) {
    var prev = el.style.scrollBehavior;
    el.style.scrollBehavior = "auto";
    el.scrollLeft = left;
    el.style.scrollBehavior = prev || "";
  }

  function ensureThumbVisible(btn) {
    if (!thumbTrack || !btn) return;
    var t = thumbTrack.getBoundingClientRect();
    var b = btn.getBoundingClientRect();
    if (b.left < t.left || b.right > t.right) {
      thumbTrack.scrollTo({
        left: btn.offsetLeft - thumbTrack.clientWidth / 2 + btn.clientWidth / 2,
        behavior: "smooth"
      });
    }
  }

  function setActiveThumb(index) {
    var matches = [];
    root.querySelectorAll("[data-pcro-gal-thumb]").forEach(function (t) {
      var on = parseInt(t.getAttribute("data-index"), 10) === index;
      t.classList.toggle("is-active", on);
      if (on) matches.push(t);
    });
    if (!matches.length || !thumbTrack) return;
    var center = thumbTrack.scrollLeft + thumbTrack.clientWidth / 2;
    var best = matches[0];
    matches.forEach(function (m) {
      var a = Math.abs(m.offsetLeft + m.clientWidth / 2 - center);
      var b = Math.abs(best.offsetLeft + best.clientWidth / 2 - center);
      if (a < b) best = m;
    });
    ensureThumbVisible(best);
  }

  function goToSlide(index) {
    if (!galTrack || index < 0 || index >= galSlides.length) return;
    galTrack.scrollTo({ left: index * galTrack.clientWidth, behavior: "smooth" });
    setActiveThumb(index);
  }

  function slideIndexByAttr(attr, value) {
    if (!value) return -1;
    for (var i = 0; i < galSlides.length; i++) {
      if (galSlides[i].getAttribute(attr) === String(value)) return i;
    }
    return -1;
  }

  function showVariantMedia(v) {
    if (!v) return;
    var index = slideIndexByAttr("data-media-id", v.media_id);
    if (index < 0) index = slideIndexByAttr("data-full", v.image);
    if (index >= 0) goToSlide(index);
  }

  function enableDrag(el, setMoved, onEnd) {
    if (!el) return null;
    var down = false;
    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    function end() {
      if (!down) return;
      down = false;
      if (pointerId !== null && dragging && el.releasePointerCapture) {
        try { el.releasePointerCapture(pointerId); } catch (err) {}
      }
      pointerId = null;
      if (!dragging) return;
      dragging = false;
      el.classList.remove("is-dragging");
      if (onEnd) onEnd();
    }

    el.addEventListener("dragstart", function (e) { e.preventDefault(); });

    el.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch" || e.button !== 0) return;
      down = true;
      dragging = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      if (setMoved) setMoved(false);
    });

    el.addEventListener("pointermove", function (e) {
      if (!down || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) <= 5) return;
        dragging = true;
        if (setMoved) setMoved(true);
        el.classList.add("is-dragging");
        if (el.setPointerCapture) {
          try { el.setPointerCapture(pointerId); } catch (err) {}
        }
      }
      el.scrollLeft = startScroll - dx;
    });

    el.addEventListener("pointerup", end);
    el.addEventListener("pointercancel", end);

    return {
      adjust: function (delta) { startScroll += delta; }
    };
  }

  if (galTrack) {
    var scrollTimer = null;
    galTrack.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var width = galTrack.clientWidth || 1;
        setActiveThumb(Math.round(galTrack.scrollLeft / width));
      }, 90);
    }, { passive: true });
    galTrack.addEventListener("touchstart", function () { swiped = false; }, { passive: true });
    galTrack.addEventListener("touchmove", function () { swiped = true; }, { passive: true });
    enableDrag(galTrack, function (moved) { swiped = moved; }, function () {
      goToSlide(Math.round(galTrack.scrollLeft / (galTrack.clientWidth || 1)));
    });
  }

  var thumbDragged = false;
  var thumbDrag = null;

  if (thumbTrack) {
    thumbDrag = enableDrag(thumbTrack, function (moved) { thumbDragged = moved; });
    thumbTrack.addEventListener("scroll", function () {
      if (!thumbLoop) return;
      var delta = 0;
      if (thumbTrack.scrollLeft < thumbSetWidth * 0.5) delta = thumbSetWidth;
      else if (thumbTrack.scrollLeft > thumbSetWidth * 1.5) delta = -thumbSetWidth;
      if (!delta) return;
      jumpScroll(thumbTrack, thumbTrack.scrollLeft + delta);
      if (thumbDrag) thumbDrag.adjust(delta);
    }, { passive: true });

    window.requestAnimationFrame(function () {
      var originals = Array.prototype.slice.call(thumbTrack.children);
      if (originals.length < 2) return;
      if (thumbTrack.scrollWidth <= thumbTrack.clientWidth + 4) return;
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (el) {
        before.appendChild(el.cloneNode(true));
        after.appendChild(el.cloneNode(true));
      });
      thumbTrack.insertBefore(before, thumbTrack.firstChild);
      thumbTrack.appendChild(after);
      thumbSetWidth = thumbTrack.scrollWidth / 3;
      thumbLoop = true;
      thumbTrack.classList.add("is-loop");
      jumpScroll(thumbTrack, thumbSetWidth);
    });
  }

  function variantIds() {
    return Object.keys(data.variants);
  }

  function findVariantByOptions(selection) {
    var ids = variantIds();
    for (var i = 0; i < ids.length; i++) {
      var v = data.variants[ids[i]];
      if (!v.options) continue;
      var match = true;
      for (var j = 0; j < selection.length; j++) {
        if (selection[j] != null && v.options[j] !== selection[j]) {
          match = false;
          break;
        }
      }
      if (match) return ids[i];
    }
    return null;
  }

  function findBestVariant(selection, index) {
    var exact = findVariantByOptions(selection);
    if (exact && data.variants[exact].available) return exact;
    var ids = variantIds();
    for (var i = 0; i < ids.length; i++) {
      var v = data.variants[ids[i]];
      if (!v.options || !v.available) continue;
      if (v.options[index] === selection[index]) return ids[i];
    }
    return exact;
  }

  function selectVariant(id) {
    if (!variantInput || !id) return;
    variantInput.value = id;
    var v = data.variants[id];
    if (atc) atc.disabled = !v || !v.available;
    if (atcText) atcText.textContent = v && v.available ? "Add to cart" : "Sold out";
    root.querySelectorAll("[data-pcro-optval]").forEach(function (b) {
      var idx = parseInt(b.getAttribute("data-option-index"), 10) || 0;
      var on = !!v && !!v.options && v.options[idx] === b.getAttribute("data-value");
      b.classList.toggle("is-selected", on);
    });
    root.querySelectorAll("[data-pcro-option-value]").forEach(function (el) {
      var idx = parseInt(el.getAttribute("data-pcro-option-value"), 10) || 0;
      if (v && v.options) el.textContent = v.options[idx] || "";
    });
    showVariantMedia(v);
    syncAll();
  }

  function selectOptionValue(index, value) {
    var current = currentVariant();
    var selection = current && current.options ? current.options.slice() : [];
    while (selection.length < optionCount) selection.push(null);
    selection[index] = value;
    var id = findBestVariant(selection, index);
    if (id) selectVariant(id);
  }

  var factsImage = "";
  var descPanel = root.querySelector('[data-pcro-panel="desc"]');
  var factsTab = root.querySelector('[data-pcro-tab="facts"]');
  if (descPanel && factsTab) {
    var firstImg = descPanel.querySelector("img");
    if (firstImg) {
      factsImage = firstImg.getAttribute("src") || "";
      if (firstImg.parentNode) firstImg.parentNode.removeChild(firstImg);
      if (factsImage) factsTab.hidden = false;
    }
    descPanel.querySelectorAll("img").forEach(function (img) {
      img.classList.add("pcro-zoomable");
    });
  }

  var modal = null;

  function closeModal() {
    if (modal && modal.parentNode) modal.parentNode.removeChild(modal);
    modal = null;
    document.removeEventListener("keydown", onModalKey);
  }

  function onModalKey(e) {
    if (e.key === "Escape" || e.keyCode === 27) closeModal();
  }

  function openModal(url) {
    if (!url) return;
    closeModal();
    modal = document.createElement("div");
    modal.className = "pcro-modal";
    modal.innerHTML = '<button type="button" class="pcro-modal__x" aria-label="Close">&#10005;</button>';
    var big = document.createElement("img");
    big.src = url;
    big.alt = "";
    modal.appendChild(big);
    document.body.appendChild(modal);
    document.addEventListener("keydown", onModalKey);
    modal.addEventListener("click", function (ev) {
      if (ev.target === modal || ev.target.className === "pcro-modal__x") closeModal();
    });
  }

  function activateTab(tab) {
    var name = tab.getAttribute("data-pcro-tab");
    root.querySelectorAll("[data-pcro-tab]").forEach(function (t) {
      var on = t === tab;
      t.classList.toggle("is-active", on);
      t.setAttribute("aria-selected", on ? "true" : "false");
    });
    root.querySelectorAll("[data-pcro-panel]").forEach(function (p) {
      var on = p.getAttribute("data-pcro-panel") === name;
      p.classList.toggle("is-active", on);
      p.hidden = !on;
    });
  }

  root.addEventListener("click", function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var optVal = target.closest("[data-pcro-optval]");
    if (optVal) {
      e.preventDefault();
      selectOptionValue(
        parseInt(optVal.getAttribute("data-option-index"), 10) || 0,
        optVal.getAttribute("data-value")
      );
      return;
    }

    var thumb = target.closest("[data-pcro-gal-thumb]");
    if (thumb) {
      e.preventDefault();
      if (thumbDragged) return;
      goToSlide(parseInt(thumb.getAttribute("data-index"), 10) || 0);
      return;
    }

    var qtyBtn = target.closest("[data-pcro-qty]");
    if (qtyBtn) {
      e.preventDefault();
      if (qtyInput) {
        var step = parseInt(qtyBtn.getAttribute("data-pcro-qty"), 10) || 0;
        var next = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.value = next < 1 ? 1 : next;
      }
      return;
    }

    var tab = target.closest("[data-pcro-tab]");
    if (tab) {
      e.preventDefault();
      if (tab.getAttribute("data-pcro-tab") === "facts") {
        openModal(factsImage);
      } else {
        activateTab(tab);
      }
      return;
    }

    if (target.closest("[data-pcro-frequency]")) return;

    var card = target.closest("[data-pcro-plan-card]");
    if (card) {
      var radio = card.querySelector("[data-pcro-mode]");
      if (radio && !radio.checked) {
        radio.checked = true;
        syncAll();
      }
      return;
    }

    var zoom = target.closest(".pcro-zoomable");
    if (zoom) {
      if (swiped) {
        swiped = false;
        return;
      }
      openModal(zoom.getAttribute("src"));
    }
  });

  root.addEventListener("change", function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (target.closest("[data-pcro-mode]") || target.closest("[data-pcro-frequency]")) {
      syncAll();
    }
  });

  function openCartDrawer() {
    var trigger = document.querySelector(".js-drawer-open-cart");
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      clearTimeout(atcResetTimer);
      setAtcState("loading");
      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { Accept: "application/json" },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () {
          setAtcState("success");
          atcResetTimer = setTimeout(function () {
            setAtcState("idle");
            syncAll();
          }, 1800);
          document.dispatchEvent(new CustomEvent("cart:updated"));
          if (window.jQuery) window.jQuery(document).trigger("added.ajaxProduct");
          if (!openCartDrawer()) window.location.href = "/cart";
        })
        .catch(function () {
          setAtcState("idle");
          form.submit();
        });
    });
  }

  if (sticky && stickyBtn) {
    if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
    stickyBtn.addEventListener("click", function () {
      if (atc && !atc.disabled) atc.click();
    });
    var buyRow = root.querySelector(".pcro-buy__row");
    if (buyRow && window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle("is-visible", show);
          document.body.classList.toggle("pcro-sticky-on", show);
        });
      }, { rootMargin: "0px 0px -40px 0px" }).observe(buyRow);
    }
  }

  syncAll();
})();
